<template>
  <!-- 新建/编辑检测项表单 -->
  <div class="hg-detection-package-form">
    <pt-form-item label="套餐名称" :labelWidth="labelWidth" :required="true">
      <el-input v-model="detectionPackaeForm.name" placeholder="请输入套餐名称" name="name" v-validate="'required'" data-vv-as="套餐名称"></el-input>
    </pt-form-item>
    <pt-form-item label="报告分析计算"  :labelWidth="labelWidth" :required="true">
      <package-product-type-selector v-model="detectionPackaeForm.packageProductionType" name="packageProductionType" v-validate="'required'" data-vv-as="报告类型"></package-product-type-selector>
    </pt-form-item>
    <pt-form-item label="实验室检测平台"  :labelWidth="labelWidth" :required="true">
      <product-bean-selector v-model="detectionPackaeForm.productBean" name="productBean" v-validate="'required'" data-vv-as="实验室检测平台" :packageProductionType="detectionPackaeForm.packageProductionType"></product-bean-selector>
    </pt-form-item>
    <template v-if="detectionPackaeForm.packageProductionType !== 'THIRDPARTY'">
      <pt-form-item label="是否基础套餐" :labelWidth="labelWidth" :required="true">
        <el-radio-group v-model="detectionPackaeForm.packageType" name="packageType" v-validate="'required'" data-vv-as="是否基础套餐">
          <el-radio label="DEFAULT_WHOLE_GENOM">是</el-radio>
          <el-radio label="OTHER">否</el-radio>
        </el-radio-group>
      </pt-form-item>
      <!-- <pt-form-item label="实验室检测平台"  :labelWidth="labelWidth" :required="true">
        <sequencing-technology-type-selector v-model="detectionPackaeForm.sequencingTechnologyType" name="sequencingTechnologyType" v-validate="'required'" data-vv-as="实验室检测平台"></sequencing-technology-type-selector>
      </pt-form-item> -->
      <pt-form-item label="基础套餐"  :labelWidth="labelWidth" :required="true" v-if="detectionPackaeForm.packageType!='DEFAULT_WHOLE_GENOM'">
          <el-button plain type="primary" @click="selectDefaultPackage">点击选择</el-button>
          <wt-input v-model="detectionPackaeForm.defaultBasePackageId" style="display:none"  name="defaultBasePackageId" v-validate="'required'" data-vv-as="基础套餐"></wt-input>
          <wt-input v-model="detectionPackaeForm.basePackageName" style="display:none"  name="basePackageName" v-validate="'required'" data-vv-as="基础套餐名字"></wt-input>
            <div :class="$style['package-table-div']" class="page-background" v-if="default_package">
                      <table :class="$style['package-table']">
                          <th>
                              <td>套餐名称</td>
                              <td>实验室检测平台</td>
                              <td>检测项个数</td>
                          </th>
                          <tr >
                              <td>{{default_package.name}}</td>
                              <td>{{default_package.sequencingTechnologyType}}</td>
                              <td>{{default_package.detectionItemCount}}</td>
                          </tr>
                      </table>
                  </div>
      </pt-form-item>
      <!-- 树形控件 -->
      <pt-form-item label="内容" :labelWidth="labelWidth" :required="true">
        <div class="treeBack">
          <el-button v-if="!buildBase" type="primary" size="small" @click="onlyAddDetection" class="addBtn">添加检测项</el-button>
          <el-button v-else type="primary" size="small" @click="handleAddTop" class="addBtn">添加分类</el-button>
          <wt-input style="display:none" v-model="items_length" name="items" v-validate="'required'" data-vv-as="内容分类"></wt-input>
          <el-tree ref="expandMenuList" class="expand-tree"
            v-if="isLoadingTree"
            :data="detectionPackaeForm.items"
            node-key="tid"
            highlight-current
            :props="defaultProps"
            :expand-on-click-node="true"
            :render-content="renderContent"
            :allow-drag="allowDrag"
            draggable
            ></el-tree>
        </div>

      </pt-form-item>
      <!-- 生成报告参数 -->
      <!-- <reportParametersForm v-model="detectionPackaeForm.reportParameters" :labelWidth="labelWidth"></reportParametersForm> -->
    </template>

    <!-- 添加分类 -->
    <summary-dialog :summaryTitle="summaryTypeTitle" :dialogVisible="summaryVisible" @update="updateSum" @addSummary="addSummary" :isEdit="summaryEdit" :form="summaryForm" @updateSummary="updateSummary"></summary-dialog>
    <!-- 检测项分类编辑／新建 -->
    <package-dialog :title="subTitle" :dialogVisible="subVisible"  @update="updateSub" @addCategory="addCategory"  :isEdit="subEdit" :form="categoryForm"  @updateCategory="updateCategory"></package-dialog>
    <!-- 检测项编辑／新建 -->
    <detection-dialog :basePackageId="basePackageId" :buildBase="buildBase" :dialogVisible="detectionVisible" :dialogTitle="detectionTitle" :detectionSelected="detectionSelected" @updateDetection="updateDetection" @addDetection="addDetection" ref="detectionDialog" :isEdit="detectionEdit" @editDetection="editDetection" :category="currentCategory" :seeDetection="seeDetection"></detection-dialog>
    <!-- 选择基础套餐 -->
    <default-package-dialog :dialogVisible="is_defualt_package" :dialogTitle="default_title" @close="closeDefaultDialog" @selectDefaultList="selectDefaultList" :default-basePackage-id="detectionPackaeForm.defaultBasePackageId"></default-package-dialog>
  </div>
</template>
<script>
/**
 * 产品新建/编辑页面
 */
import { validate } from 'utils/validate'
// import reportParametersForm from 'cps/gene-product/selector/report-parameters-form'
import TreeRender from 'cps/gene-product/selector/tree_render'
import packageDialog from 'cps/gene-product/selector/package-dialog'
import detectionDialog from 'cps/gene-product/selector/detection-dialog'
import summaryDialog from 'cps/gene-product/selector/summary-dialog'
import defaultPackageDialog from 'cps/gene-product/selector/default-package-dialog'
// import sequencingTechnologyTypeSelector from 'cps/gene-product/selector/import-config-params/componentsWithData/sequencing-technology-type-selector'
import packageProductTypeSelector from 'cps/gene-product/selector/package-product-type-selector'
import productBeanSelector from 'cps/gene-product/selector/product-bean-selector'

export default {
  name: 'detection-package-form',
  components: {
    // reportParametersForm,
    packageDialog,
    detectionDialog,
    // sequencingTechnologyTypeSelector,
    summaryDialog,
    defaultPackageDialog,
    packageProductTypeSelector,
    productBeanSelector
  },
  props: {
    value: {
      type: Object,
      default: () => {}
    },
    defaultBasePackage: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    buildBase () {
      return this.detectionPackaeForm.packageType === 'DEFAULT_WHOLE_GENOM'
    },
    basePackageId () {
      return this.detectionPackaeForm.defaultBasePackageId
    },
    isEdit () {
      return this.$route.params.id
    }
  },
  data () {
    return {
      // 概述分类参数
      summaryTypeTitle: '添加分类',
      summaryVisible: false,
      summaryForm: {},
      summaryEdit: false, // 是否是修改
      startTid: 0,
      currentParentNodeData: {}, // 用于存储编辑当前节点的父节点数据
      currentParentNode: {}, // 用于存储编辑当前节点的父节点
      // 子分类参数
      subTitle: '添加子分类',
      subVisible: false,
      categoryForm: {},
      subEdit: false,
      // 检测项参数
      detectionData: {},
      detectionVisible: false,
      detectionTitle: '添加检测项',
      isLoadingTree: false, // 是否加载节点树
      defaultProps: {
        children: 'items',
        label: 'name'
      },
      defaultExpandKeys: [], // 默认展开的树节点
      labelWidth: '120px',
      detectionSelected: [],
      detectionPackaeForm: JSON.stringify(this.value) !== '{}' ? this.value : {
        name: '',
        agentId: '',
        items: [],
        productBean: {},
        reportParameters: {},
        packageType: 'OTHER',
        defaultBasePackageId: ''
      },
      detectionEdit: false,
      // 传入的检测项分类
      currentCategory: '',
      // 查看的检测项
      seeDetection: {},
      is_defualt_package: false,
      default_title: '选择基础套餐',
      default_package: null,
      items_length: this.value && this.value.items && this.value.items.length > 0 ? this.value.items.length : null
    }
  },
  watch: {
    detectionPackaeForm: {
      handler: function (val, oldval) {
        console.log('watch---detectionPackaeForm--', val)
        this.detectionPackaeForm = val
        this.items_length = val.items && val.items.length > 0 ? val.items.length : null
        this.$emit('input', val)
      },
      deep: true
    },
    'detectionPackaeForm.packageType' (val) {
      this.detectionPackaeForm.items = []
      this.detectionPackaeForm.defaultBasePackageId = ''
      this.default_package = null
      this.items_length = null
    },
    summaryForm (val) {
      console.log(val)
    },
    defaultBasePackage: {
      handler: function (val, oldval) {
        if (val && !oldval) {
          this.default_package = val
        }
      }
    },
    'detectionPackaeForm.items': {
      handler: function (val) {
        this.items_length = val.length > 0 ? val.length : null
      },
      deep: true
    }
  },
  methods: {
    closeDefaultDialog () {
      this.is_defualt_package = false
    },
    selectDefaultList (val) {
      this.default_package = val
      this.detectionPackaeForm.defaultBasePackageId = val.id
      this.detectionPackaeForm.basePackageName = val.name
      this.is_defualt_package = false
    },
    selectDefaultPackage () {
      this.is_defualt_package = true
    },
    formValidate () {
      // 凡是通过平台建的套餐都是非系统套餐，并不能根据packageType === 'DEFAULT_WHOLE_GENOM'来保证
      this.detectionPackaeForm.engineDefault = false// this.detectionPackaeForm.packageType === 'DEFAULT_WHOLE_GENOM'
      return validate(this, this.detectionPackaeForm)
    },
    reset () {
      this.detectionPackaeForm = {
        name: '',
        agentId: '',
        items: []
      }
    },
    // -----------------------------树形控件样式
    handleAddTop () {
      this.summaryVisible = true
      this.summaryEdit = false
    },
    // 获取检测项的一个迭代方法，通过闭包实现
    getDetectionsIteration (data) {
      let detections = []
      if (data.items && data.items.length) {
        (function iterat (data) {
          data.items.forEach(ele => {
            if (ele.type === 'DETECTION') {
              detections.push(ele)
            } else {
              iterat(ele)
            }
          })
        })(data)
      }
      return detections
    },
    onlyAddDetection () { // 增加detection节点
      if (!this.basePackageId) {
        this.$message.error('请选择一个基础套餐！')
        return
      }
      this.detectionEdit = false
      this.detectionVisible = true
      this.detectionTitle = '添加检测项'
      this.detectionData = this.detectionPackaeForm
      this.currentParentNode = this.detectionPackaeForm
      // // 把type为DETECTION的传递给detection-dialog列表
      let detections = this.getDetectionsIteration(this.detectionPackaeForm)
      this.detectionSelected = detections
      // // 处理该节点属于的category
      // if (n.level === 1) {
      this.currentCategory = this.detectionPackaeForm.items[0] ? this.detectionPackaeForm.items[0].detectionItemCategory : ''
      // }
      // if (n.level === 2) {
      //   this.currentCategory = n.parent.data.detectionItemCategory
      // }
      // if (n.level === 3) {
      //   this.currentCategory = n.parent.parent.data.detectionItemCategory
      // }
      this.seeDetection = {}
    },
    // 更新一级分类的dialogVisible
    updateSum (val) {
      this.summaryVisible = val
    },
    // 添加一级分类的表单
    addSummary (form) {
      form.tid = this.startTid++
      this.detectionPackaeForm.items.push(form)
    },
    updateNodeByTid (child, parentNode) {
      parentNode.items.forEach((e, index) => {
        if (e.tid === child.tid) {
          this.$set(parentNode.items, index, child)
        }
      })
    },
    // 更新一级分类
    updateSummary (form) {
      console.log('form', form)
      this.updateNodeByTid(form, this.currentParentNodeData)
    },
    // 修改一级分类及子分类
    handleEditCategory (s, d, n) { // 编辑category节点
      if (n.level === 1) {
        this.summaryVisible = true
        this.summaryTypeTitle = '编辑分类'
        this.summaryEdit = true
        this.currentParentNodeData = this.detectionPackaeForm
        this.summaryForm = JSON.parse(JSON.stringify(d))
      } else {
        this.subVisible = true
        this.subTitle = '编辑子分类'
        this.subEdit = true
        console.log('n', n)
        this.currentParentNodeData = n.parent.data
        this.categoryForm = JSON.parse(JSON.stringify(d))
        // console.log('当前修改的node',this.categoryForm)
      }
    },
    // 子分类的方法
    handleAddCategory (s, d, n) { // 增加category节点
      this.subVisible = true
      this.subTitle = '添加子分类'
      this.subEdit = false
      this.currentParentNodeData = d
      this.currentParentNode = n
    },
    updateSub (val) {
      this.subVisible = val
    },
    addCategory (form) {
      form.tid = this.startTid++
      if (!this.currentParentNodeData.items) {
        this.$set(this.currentParentNodeData, 'items', [])
      }
      this.currentParentNodeData.items.push(form)
      this.openParentNode()
    },
    updateCategory (form) {
      console.log('form', form)
      this.updateNodeByTid(form, this.currentParentNodeData)
    },
    allowDrag (draggingNode) {
      return true
    },
    initExpand () {
      // 为每一个节点赋予一个唯一值tid
      this.giveTid(this.detectionPackaeForm)
      console.log('init---------', this.detectionPackaeForm)
      this.isLoadingTree = true
    },
    giveTid (obj) {
      if (obj.items && obj.items.length) {
        obj.items.forEach(ele => {
          ele.tid = this.startTid++
          this.giveTid(ele)
        })
      }
    },
    renderContent (h, { node, data, store }) { // 加载节点
      let that = this
      return h(TreeRender, {
        props: {
          DATA: data,
          NODE: node,
          STORE: store
          // maxexpandId: that.non_maxexpandId
        },
        on: {
          nodeCategoryAdd: (s, d, n) => that.handleAddCategory(s, d, n),
          nodeCategoryEdit: (s, d, n) => that.handleEditCategory(s, d, n),
          nodeDetectionAdd: (s, d, n) => that.handleAddDetection(s, d, n),
          nodeDetectionEdit: (s, d, n) => that.handleEditDetection(s, d, n),
          nodeDel: (s, d, n) => that.handleDelnode(s, d, n)
        }
      })
    },

    // ----------------------------增加detection节点
    handleAddDetection (s, d, n) { // 增加detection节点
      console.log('d----------', d)
      this.detectionEdit = false
      this.detectionVisible = true
      this.detectionTitle = '添加检测项'
      this.detectionData = d
      this.currentParentNode = n
      // 把type为DETECTION的传递给detection-dialog列表
      let detections = []
      if (d.items && d.items.length) {
        d.items.forEach(ele => {
          if (ele.type === 'DETECTION') {
            detections.push(ele)
          }
        })
      }
      this.detectionSelected = detections
      // 处理该节点属于的category
      if (n.level === 1) {
        this.currentCategory = d.detectionItemCategory
      }
      if (n.level === 2) {
        this.currentCategory = n.parent.data.detectionItemCategory
      }
      if (n.level === 3) {
        this.currentCategory = n.parent.parent.data.detectionItemCategory
      }
      this.seeDetection = {}
    },
    addDetection (detections) {
      if (!this.detectionData.items) {
        this.$set(this.detectionData, 'items', [])
      }
      // 所有的检测项以新传入的为准
      let targetItems = []
      detections.forEach((detection, i) => {
        detection.tid = this.startTid++
        detection.type = 'DETECTION'
        detection.name = detection.chineseName
        targetItems.push(detection)
      })
      this.detectionData.items = targetItems
      this.openParentNode()
    },
    // 新增的同时展开父节点
    openParentNode () {
      this.$set(this.currentParentNode, 'expanded', true)
    },
    // 修改检测项
    editDetection (detections) {
      if (detections.length === 0) {
        // 删除检测项
        this.delDetection(this.detectionPackaeForm, this.detectionData)
      } else {
        this.updateNodeByTid(detections[0], this.currentParentNodeData)
      }
    },
    // digui
    delDetection (arr, data) {
      arr.items.forEach((level1, i) => {
        if (level1.type === 'DETECTION') {
          if (data.name === level1.name) {
            arr.items.splice(i, 1)
          }
        } else {
          this.delDetection(level1, data)
        }
      })
    },
    handleEditDetection (s, d, n) {
      this.detectionEdit = true
      this.detectionVisible = true
      this.detectionTitle = '查看/修改检测项'
      this.detectionData = d
      this.detectionSelected = [d]
      // 查看或修改的时候会调用搜索直接搜
      if (d.category) {
        this.currentCategory = d.category
      }
      if (n.level === 2) {
        this.currentCategory = n.parent.data.detectionItemCategory
      }
      if (n.level === 3) {
        this.currentCategory = n.parent.parent.data.detectionItemCategory
      }
      this.seeDetection = d
      this.currentParentNodeData = n.parent.data
      // this.currentParentNode = n
    },
    updateDetection (val) {
      // 每次关闭都重置分类
      this.currentCategory = ''
      this.detectionVisible = val
    },
    handleDelnode (s, d, n) { // 删除节点
      let that = this
      let tip = `确定要删除${d.name}节点及子节点吗？`
      if (!d.items) {
        tip = `确定要删除${d.name}节点吗？`
      }
      let delNode = () => {
        let list = n.parent.data.items || n.parent.data // 节点同级数据
        let _index // 要删除的index
        list.map((c, i) => {
          if (d.name) {
            if (d.name === c.name) {
              _index = i
            }
          } else {
            if (d.detectionItemId === c.detectionItemId) {
              _index = i
            }
          }
        })
        list.splice(_index, 1)
        this.$message.success('删除成功！')
      }
      let isDel = () => {
        that.$confirm(tip, '提示', {
          confirmButtonText: '确认',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          delNode()
        }).catch(() => {
          return false
        })
      }
      isDel()
    }
  },
  mounted () {
    this.initExpand()
  }
}

</script>
<style lang="less">
.hg-detection-package-form{
  .el-input,.el-select{
    max-width: 280px;
    width:100%;
  }
  .treeBack{
    background:#fafafa;
    padding:20px 20px;
  }
  .el-tree{
    max-width: 1000px;
  }
  .el-tree-node__content{
    height: 32px;
  }
  .addBtn{
    margin-bottom: 20px;
  }
}

</style>
<style module lang="less">
.package-table-div{
    margin-top: 10px;
    padding: 10px 20px 30px;
}
.specicalBox{
  display: flex;
  flex-direction: column;
  .itemBox + .itemBox {
    margin-left: 0rem !important;
  }
}
.package-table{
    display: table!important;
    width: 100%;
    border-collapse:collapse!important;
    th,tr{
        width: 100%!important;
        max-width: 100%!important;
        display: table-row;
        padding: 0!important;
        list-style-type:none;
        border-bottom: 1px solid #C6C9D3;
        color: #818181
    }
    td{
        text-align: center;
    }
}
</style>
